import { render, staticRenderFns } from "./Agenda.vue?vue&type=template&id=4ea046c0"
import script from "./Agenda.vue?vue&type=script&lang=js"
export * from "./Agenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ea046c0')) {
      api.createRecord('4ea046c0', component.options)
    } else {
      api.reload('4ea046c0', component.options)
    }
    module.hot.accept("./Agenda.vue?vue&type=template&id=4ea046c0", function () {
      api.rerender('4ea046c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/lesson/Agenda.vue"
export default component.exports